import { H5, P3 } from '@repo/ui/components/Typography';
import { handleTextOverflow } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ButtonWrapper = styled.div<{
  isActive: boolean;
  isNewThemeActive: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 8px;
  border-radius: 8px;
  box-sizing: border-box;
  width: 100%;
  background: ${({ isActive, isNewThemeActive }) =>
    isActive
      ? `${isNewThemeActive ? themeStyle.varBlueLight30 : themeStyle.varSelectionBlue10}`
      : 'transparent'};
  border: ${({ isActive, isNewThemeActive }) =>
    isActive
      ? `1px solid ${isNewThemeActive ? themeStyle.varBlueMain : themeStyle.varSelectionBlue}`
      : ''};

  &:hover {
    background: ${({ isActive, isNewThemeActive }) =>
      isActive
        ? `${isNewThemeActive ? themeStyle.varBlueLight30 : themeStyle.varSelectionBlue10}`
        : themeStyle.varInkSuperLight};
    cursor: ${({ isActive }) => (!isActive ? `pointer` : `unset`)};
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  ${handleTextOverflow}
`;

export const Title = styled(H5)`
  max-width: 100%;
`;

export const Subtitle = styled(P3)`
  max-width: 100%;
`;
